module.exports = __webpack_public_path__ + "img/app-store.370dc57d.png";